import * as Avatar from '@radix-ui/react-avatar';
import { cn } from '../../lib/cn';

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
};

function buildInitials(nameOrEmail = '') {
  const source = nameOrEmail.includes('@') ? nameOrEmail.split('@')[0] : nameOrEmail;
  const tokens = source
    .replace(/[._-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!tokens.length) {
    return 'FC';
  }

  return tokens
    .slice(0, 2)
    .map((token) => token[0]?.toUpperCase())
    .join('');
}

function AppAvatar({ name, email, size = 'md', className, src }) {
  const displayName = name || email || 'Family Copilot';

  return (
    <Avatar.Root
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-app-border/70 bg-app-surface-alt shadow-subtle',
        sizeClasses[size] || sizeClasses.md,
        className
      )}
    >
      <Avatar.Image className="h-full w-full object-cover" src={src} alt={displayName} />
      <Avatar.Fallback
        delayMs={200}
        className="flex h-full w-full items-center justify-center bg-app-accent/10 font-semibold text-app-accent-strong"
      >
        {buildInitials(displayName)}
      </Avatar.Fallback>
    </Avatar.Root>
  );
}

export default AppAvatar;
